import React, {useEffect, useState} from 'react';
import {useTranslate} from "../../../system/useTranslate";
import {useTask} from "../../../models/task/use-task";
import AccordionDataView from "../components/accordion-dataview";
import {Checkbox} from "primereact/checkbox";
import Avatar from "../../../system/components/avatar";
import {isPast} from "../../../system/utils";
import TaskSidebar from "../../projects/components/task-sidebar";
import {setPrompt} from "../../../system/app-slice";
import {useDispatch, useSelector} from "react-redux";
import Icon from "../../../system/components/icon";
import {useNavigate} from "react-router-dom";
import {TaskDateTime} from "../components/task-time-range";
import TaskListFilter from "../components/task-list-filter";
import TaskFocusControls from "../../../system/focus/task-focus-controls";
import {RecurrenceBadge} from "../components/task-recurrence-badge";
import TaskDecisionTag from "../../projects/meetings/task-decision-tag";
import {MeetingCells, bucketMeetings, meetingRowClass} from "../../projects/meetings/my-meetings-list";
import {openMyMeeting} from "../../projects/meetings/meeting-sidebar";
import {useMyMeetings} from "../../projects/meetings/my-meetings-store";

function Tasks({tasks, createTask, updateTask}) {
    const [tabs, setTabs] = useState([]);
    const translate = useTranslate();
    const [selectedTask, setSelectedTask] = useState();
    const task = useTask();
    const dispatch = useDispatch();
    const {workspaceMembershipData} = useSelector(state => state.app);
    const navigate = useNavigate();
    const [filteredTasks, setFilteredTasks] = useState([])
    // the meetings a person is invited to, owns or created sit among their tasks, drawn differently (docs/tasks/30-meeting-cards.md)
    const {meetings: myMeetings, today: meetingsToday} = useMyMeetings();
    // a filter that narrows the tasks (a person, a project, a word) hides the meetings, which it cannot apply to
    const filtering = Array.isArray(filteredTasks) && Array.isArray(tasks) && filteredTasks.length !== tasks.length;

    const canUpdateTaskStatus = (task) => Boolean(
        task?.assignee && workspaceMembershipData &&
        String(task.assignee.documentId || task.assignee.id)
        === String(workspaceMembershipData.documentId || workspaceMembershipData.id),
    );


    useEffect(() => {
        const meetingBuckets = bucketMeetings(filtering ? [] : myMeetings, meetingsToday);
        let _tabs = [
            {
                title: translate("overdue"),
                value: [...task.filter(filteredTasks ?? tasks, "overdue"), ...meetingBuckets.overdue],
                className: "text-red-500"
            },
            {
                title: translate("today"),
                value: [...meetingBuckets.today, ...task.filter(filteredTasks ?? tasks, "today")],
                placeholder: translate("add-tasks-for-time-remain").replace("{{TIME_REMAIN}}", translate("today")),
                quickCreateCallback: (e) => {
                    e.value && createTask({title: e.value})
                }
            },
            {
                title: translate("this-week"),
                value: [...meetingBuckets.week, ...task.filter(filteredTasks ?? tasks, "this-week")],
                placeholder: translate("add-tasks-for-time-remain").replace("{{TIME_REMAIN}}", translate("this-week")),
                quickCreateCallback: (e) => {
                    e.value && createTask({title: e.value})
                }
            },
            {title: translate("future"), value: [...meetingBuckets.future, ...task.filter(filteredTasks ?? tasks, "future")]},
            {title: translate("no-due"), value: task.filter(filteredTasks ?? tasks, "no-due")},
            {
                title: translate("done"),
                value: [...task.filter(filteredTasks ?? tasks, "done"), ...meetingBuckets.done],
                placeholder: translate("add-tasks-for-time-remain").replace("{{TIME_REMAIN}}", translate("this-week"))
            }
        ]
        if (tasks) {
            setTabs(_tabs);
        }

        let _tasksSummery = _tabs.map(ts => ({
            title: ts.title,
            tasks: ts.value.filter(tsv => !tsv.__meeting).map(tsv => ({title: tsv.title, status: tsv.taskStatus, assignee: tsv.assignee?.member?.fullname}))
        }))
        dispatch(setPrompt(`تو دستیار زوفینو هستی. داده های تسک ها رو در اختیار داری و یه خلاصه وضعیت در حد 150 کلمه به من گزارش میدی. طوری که بتونم برای ادامه تصمیم گیری کنم ${JSON.stringify(_tasksSummery)}`))
        // dispatch(setPrompt("تو دستیار زوفینو هستی و من کاربر زوفینو هستم. در بخش کسب و کارها وارد شدم و نیاز به کمک دارم. تو باید در مورد ایجاد دستور کار به من توضیح بدی که از قسمت ایجاد دستور کار میتونم دستور کار جدید بسازم و از لیست دستورکارها، دستور کارهای پروژه رو ببینم. این توضیح از 50 کلمه بیشتر نباید بشه"))

    }, [tasks, filteredTasks, myMeetings, meetingsToday]);

    // <span className="flex-1">{translate("task-title")}</span>
    // <span className="w-7rem">{translate("assignee")}</span>
    // <span className="w-7rem">{translate("dueDate")}</span>
    // <span className="w-7rem">{translate("projects")}</span>
    // <span className="w-7rem">{translate("team")}</span>
    // <span className="w-7rem">{translate("access")}</span>


    return (
        <div className="flex flex-column h-full min-h-0">
            <TaskListFilter showDateFilter onChange={setFilteredTasks} tasks={tasks}/>
            <AccordionDataView tabs={tabs} activeIndex={[0, 1, 2, 4]} rowClassName={meetingRowClass} onRowClick={(row) => row?.__meeting && openMyMeeting(row.key)} columns={[
                {
                    header: "",
                    headerClassName: "w-4rem",
                    cellClassName: "w-4rem",
                    render: (row) => row.__meeting ? MeetingCells.check(row) : <div className="pr-2">
                        <Checkbox checked={row.taskStatus === "done"}
                                  disabled={!canUpdateTaskStatus(row)}
                                  onChange={(e) => {
                                      if (!canUpdateTaskStatus(row)) return;

                                      updateTask(row, {
                                          doneAt: row?.taskStatus === "done" ? null : Date.now(),
                                          taskStatus: row?.taskStatus === "done" ? "todo" : "done"
                                      })
                                  }}/>
                    </div>
                },
                {
                    header: translate("task-title"),
                    headerClassName: "flex-1",
                    cellClassName: "flex-1",
                    render: (row) => row.__meeting ? MeetingCells.title(row) : (
                        <div data-task-sidebar-trigger="true" className="flex align-items-center gap-2 w-full h-full">
                            <span className="inline-flex align-items-center gap-2" dir="ltr">
                                <span dir="rtl" className={row.occurrenceStatus === "skipped" ? "line-through text-500" : ""}>{row.title}</span>
                                <TaskFocusControls task={row} compact/>
                                <RecurrenceBadge task={row}/>
                            </span>
                            <TaskDecisionTag task={row}/>
                            {
                                row.parentTask && (
                                    <>
                                        <Icon icon="mi mi:chevron_right" className="text-sm text-400"/>
                                        <span className="text-3xs text-400 font-bold">{row.parentTask?.title}</span>
                                    </>
                                )
                            }
                            {row.childrenTasks?.length > 0 && (
                                <span
                                    className="text-xs surface-200 border-1 border-300 border-round px-2 flex align-items-center gap-1">
                                <Icon icon="mi mi:graph_1" className="text-sm"/>
                                    {row.childrenTasks?.length}
                            </span>
                            )}
                        </div>
                    )
                    ,
                    onCellClick: (e) => {
                        if (e?.__meeting) return;
                        setSelectedTask(e)
                    }
                },
                {
                    header: translate("assignee"),
                    headerClassName: "w-7rem",
                    cellClassName: "w-7rem",
                    render: (row) => row.__meeting ? MeetingCells.owner(row) : <Avatar memberData={row.assignee?.member}/>
                },
                {
                    header: translate("startAt"),
                    headerClassName: "w-10rem",
                    cellClassName: "w-10rem text-xs",
                    render: (row) => row.__meeting ? MeetingCells.date(row) : <TaskDateTime value={row.startAt}/>
                },
                {
                    header: translate("dueDate"),
                    headerClassName: "w-10rem",
                    cellClassNameDynamic: (row) => `w-10rem text-xs ${!row.__meeting && row.dueDate && isPast(new Date(row.dueDate).getTime() / 1000, 1, "days") ? "text-red-500" : ""}`,
                    render: (row) => row.__meeting ? null : <TaskDateTime value={row.dueDate}/>
                },
                {
                    header: translate("projects"),
                    headerClassName: "w-7rem",
                    cellClassName: "w-7rem",
                    render: (row) => row.__meeting ? MeetingCells.project(row) : <div className="w-7rem flex flex-wrap gap-1">{row.projects?.map(p => (
                        <span onClick={() => {
                            navigate(`/projects/${p.documentId}`)
                        }}
                              className="border-round px-1 border-1 border-200 cursor-pointer surface-100 text-2xs">{p.title}</span>))}</div>
                },
            ]}/>
            {tasks && <TaskSidebar onOtherTaskClicked={(e) => {
                setSelectedTask(tasks.find(task => task.id === e?.id))
            }} createTask={createTask} selectedTask={tasks.find(task => task.id === selectedTask?.id)}
                                   setSelectedTask={setSelectedTask} updateTask={updateTask}/>}
        </div>)

}

/* Shared filtering UI lives in components/task-list-filter.js. */
/*
function TaskFilter({onChange, tasks}) {
    const task = useTask()
    const translate = useTranslate()
    const datePickerRef = useRef(null)
    const workspaceMembershipData = useSelector(state => state.app.workspaceMembershipData)
    // const [filteredTasks, setFilteredTasks] = useState(tasks)
    const [filters, setFilters] = useState({
        status: null,
        project: null,
        assignee: null,
        dateRange: {start: null, end: null},
        dateFilter: null,
        taskType: null,
        member: null,
        search: "",
    })
    const options = [{
        label: translate("done"),
        value: "done"
    }, {
        label: translate("doing"),
        value: "doing"
    },
    ]
    const projectsOptions = [
        {
            id: null,
            title: translate("all")
        },
        ...new Map(tasks?.flatMap(t =>
            t.projects ?? []).map(p =>
            [p.id, p])).values()]

    const assigneeOptions = [
        {
            id: null,
            fullname: translate("all")
        },
        ...new Map((tasks ?? [])?.filter(t =>
            t.assignee).map(t =>
            [t.assignee.id, t.assignee])).values()]

    const dateOptions = [
        {label: "هفته آینده", value: "next-week"},
        {label: "این هفته", value: "this-week"},
    ]
    const taskTypeOptions = [
        ...new Map(
            (tasks ?? [])
                .filter(t => t.task_type)
                .map(t => [t.task_type.id, t.task_type])
        ).values()
    ]
    const normalizeMember = member => member?.member ?? member;
    const availableMembers = [
        ...(workspaceMembershipData?.workspace?.workspace_memberships ?? []).map(normalizeMember),
        ...(tasks ?? []).flatMap(task => task.members ?? []).map(normalizeMember),
    ].filter(member => member?.id || member?.documentId);
    const memberOptions = [
        {
            id: null,
            fullname: translate("all")
        },
        ...new Map(
            availableMembers.map(member => [member.documentId ?? member.id, member])
        ).values()
    ]


    useEffect(() => {
        let result = [...(tasks ?? [])]
        if (filters.search?.trim()) {
            const value = filters.search.trim().toLocaleLowerCase()
            result = result.filter(task =>
                String(task.title ?? "").toLocaleLowerCase().includes(value)
            )
        }
        if (filters.status) {
            result = task.filter(result, filters.status)
        }
        if (filters.project) {
            result = result.filter(t =>
                t.projects?.some(p => p.id === filters.project.id));
        }
        if (filters.assignee) {
            result = result.filter(t => t.assignee?.id === filters.assignee.id);
        }
        if (filters.taskType) {
            result = result.filter(
                t => t.task_type?.id === filters.taskType.id
            )
        }
        if (filters.member) {
            const selectedMemberKey = filters.member.documentId ?? filters.member.id;
            result = result.filter(task =>
                task.members?.some(
                    member => {
                        const normalizedMember = normalizeMember(member);
                        return String(normalizedMember?.documentId ?? normalizedMember?.id) === String(selectedMemberKey);
                    }
                )
            )
        }

        if (filters.dateFilter === "this-week") {
            const range = getWeekRange(0);
            result = filterByDueDateRange(result, range.start, range.end);
        }
        if (filters.dateFilter === "next-week") {
            const range = getWeekRange(1);
            result = filterByDueDateRange(result, range.start, range.end);
        }
        if (filters.dateFilter === "custom") {
            const {start, end} = filters.dateRange
            result = filterByDueDateRange(result, start, end)
        }

        onChange?.(result)
    }, [filters, tasks]);

    // useEffect(() => {
    //     setFilteredTasks(tasks)
    //     console.log(tasks)
    // }, [tasks]);
    //
    // useEffect(() => {
    //     onChange?.(filteredTasks)
    // }, [filteredTasks]);

    return (
        <div className="flex flex-column w-full p-2 md:p-3 gap-2">

        <div className="flex flex-row flex-nowrap align-items-center gap-2 w-full overflow-x-auto pb-1">
            <SelectButton
            className="ltr p-button-sm border-round-xl overflow-hidden flex-none white-space-nowrap order-1"
            pt={{
                button: {
                    className: "text-xs font-normal px-2 white-space-nowrap",
                    style: {height: FILTER_CONTROL_HEIGHT}
                }
            }}

            value={filters.status}
                    options={options}
                    onChange={(e) => setFilters({...filters, status: e.value})
                    }/>

                <Divider layout="vertical" className="hidden lg:block m-0 order-2"/>

                <div className="flex flex-row flex-nowrap align-items-center gap-2 flex-none order-0">
                    <SelectButton options={dateOptions}
                                  className="ltr p-button-sm border-round-xl overflow-hidden flex-none white-space-nowrap"
                                  pt={{
                                      button: {
                                          className: "text-xs font-normal px-2 white-space-nowrap",
                                          style: {height: FILTER_CONTROL_HEIGHT}
                                      }
                                  }}

                                  value={filters.dateFilter}
                                  onChange={(e) => setFilters(prev => ({...prev, dateFilter: e.value}))}/>

                    <Button outlined
                            className="px-3 text-xs font-normal border-round-xl border-200 text-600 flex-none white-space-nowrap surface-0"
                            style={{height: FILTER_CONTROL_HEIGHT}}
                            label=" date-picker.custom-range"
                            icon="mi mi:calendar_month"
                            onClick={(e) => datePickerRef.current?.toggle(e)}/>

                    <OverlayPanel ref={datePickerRef}>
                        <ZofinoDatepicker
                            value={filters.dateRange}
                            config={{range: true}}
                            onChange={(value) => {
                                setFilters(prev => ({
                                    ...prev,

                                    dateFilter: "custom",
                                    dateRange: value
                                }))
                            }}
                            readOnlyInput
                        />
                    </OverlayPanel>
                </div>

                <Divider layout="vertical" className="hidden lg:block m-0 order-3"/>

                <div className="flex flex-row flex-nowrap gap-2 flex-none order-4">
                    <Dropdown
                        className="w-12rem h-2-5rem flex-none border-round-xl text-xs font-normal"
                        style={{height: FILTER_CONTROL_HEIGHT}}
                        pt={{
                            input: {className: "text-xs font-normal"},
                            item: {className: "text-xs font-normal"},
                        }}
                        value={filters.project}
                        options={projectsOptions}
                        optionLabel="title"
                        placeholder={translate("project")}
                        onChange={(e) => setFilters({
                            ...filters,
                            project: e.value?.id ? e.value : null
                        })
                        }/>

                    <Dropdown
                        className="w-12rem h-2-5rem flex-none border-round-xl text-xs font-normal"
                        style={{height: FILTER_CONTROL_HEIGHT}}
                        pt={{
                            input: {className: "text-xs font-normal"},
                            item: {className: "text-xs font-normal"},
                        }}
                        value={filters.assignee}
                        options={assigneeOptions}
                        optionLabel="fullname"
                        placeholder={translate("assignee")}
                        onChange={(e) =>
                            setFilters({
                                ...filters,
                                assignee: e.value?.id ? e.value : null
                            })
                        }/>

                    <Dropdown
                        className="w-12rem h-2-5rem flex-none border-round-xl text-xs font-normal"
                        style={{height: FILTER_CONTROL_HEIGHT}}
                        pt={{
                            input: {className: "text-xs font-normal"},
                            item: {className: "text-xs font-normal"},
                        }}
                        value={filters.member}
                        options={memberOptions}
                        optionLabel="fullname"
                        placeholder="members"
                        onChange={(e) =>
                            setFilters(prev => ({
                                ...prev,
                                member: e.value?.id ? e.value : null
                            }))
                        }
                    />
                </div>
            <div className="w-16rem flex-none order-5" style={{marginRight: "auto"}}>
                <IconField className="w-full">
                        <InputIcon className="pi pi-search"/>
                        <InputText
                            className="w-full h-2-5rem p-inputtext-sm surface-100 border-round-xl text-xs font-normal"
                            style={{height: FILTER_CONTROL_HEIGHT}}
                            value={filters.search}
                            placeholder={translate("quick-search")}
                            onChange={(e) =>
                                setFilters(prev => ({
                                    ...prev,
                                    search: e.target.value
                                }))
                            }
                        />
                    </IconField>
                </div>
        </div>
            <div className="flex flex-wrap gap-2 pt-1">
                {taskTypeOptions.map(type => (
                    <Button
                        key={type.id}
                        outlined
                        size="small"
                        label={type.title}
                        icon={`mi mi:${type.icon}`}
                        className={`border-round-xl h-2rem border-dashed text-xs font-normal ${
                            filters.taskType?.id === type.id
                                ? "p-button-primary"
                                : "surface-100 text-color-secondary border-gray-300 hover:surface-200"
                        }`}
                        onClick={() => setFilters(prev => ({
                            ...prev,
                            taskType: prev.taskType?.id === type.id ? null : type
                        }))}
                    />
                ))}
            </div>

            </div>
    )
}
*/

export default Tasks;
